import { render, staticRenderFns } from "./CareerContentCN.vue?vue&type=template&id=0015c0b8&scoped=true"
import script from "./CareerContentCN.vue?vue&type=script&lang=js"
export * from "./CareerContentCN.vue?vue&type=script&lang=js"
import style0 from "./CareerContentCN.vue?vue&type=style&index=0&id=0015c0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015c0b8",
  null
  
)

export default component.exports